export const PERMISSION_REGISTRY = {
  global: {
    label: 'Global Settings',
    submodules: {
      system: {
        label: 'System Access Control',
        actions: [{ key: '*', label: 'System* (Full Access Bypass)' }]
      },
      notifications: {
        label: 'Notification Dispatcher',
        actions: [{ key: 'write', label: 'Manual Notification Dispatcher (Send)' }]
      },
      dialer: {
        label: 'Dialer Customer Calls',
        actions: [{ key: 'write', label: 'Initiate Customer Call' }]
      }
    }
  },
  team_review: {
    label: 'Team Review',
    submodules: {
      attendance: {
        label: 'Attendance Management',
        actions: [
          { key: 'read', label: 'View Attendance Tab & Data' },
          { key: 'write', label: 'Create/Edit Attendance Records' },
          { key: 'export', label: 'Export Attendance & Muster Reports' },
          { key: 'manage_columns', label: 'Manage Columns' }
        ]
      },
      map: {
        label: 'Live Map Tracking',
        actions: [
          { key: 'read', label: 'View Map Tab & Live Locations' },
          { key: 'export', label: 'Export Map Data' }
        ]
      },
      calendar: {
        label: 'Team Calendar',
        actions: [{ key: 'read', label: 'View Team Calendar' }]
      },
      roster: {
        label: 'Shift Roster',
        actions: [
          { key: 'read', label: 'View Roster Tab' },
          { key: 'export', label: 'Export Shift Data' },
          { key: 'assign_shift', label: 'Assign & Manage Shifts' }
        ]
      }
    }
  },
  organization: {
    label: 'Organization Hierarchy',
    submodules: {
      employees: {
        label: 'Employees Management',
        actions: [
          { key: 'read', label: 'View Employees' },
          { key: 'create', label: 'Add Employee' },
          { key: 'update', label: 'Edit Employee' },
          { key: 'delete', label: 'Delete Employee' },
          { key: 'export', label: 'Export Employees' }
        ]
      },
      roles: {
        label: 'Roles & IAM Policies',
        actions: [
          { key: 'read', label: 'View Roles' },
          { key: 'create', label: 'Create Role' },
          { key: 'update', label: 'Edit Role' },
          { key: 'delete', label: 'Delete Role' }
        ]
      },
      branches: {
        label: 'Branches',
        actions: [
          { key: 'read', label: 'View Branches' },
          { key: 'create', label: 'Add Branch' },
          { key: 'update', label: 'Edit Branch' },
          { key: 'delete', label: 'Delete Branch' }
        ]
      },
      departments: {
        label: 'Departments & Designations',
        actions: [
          { key: 'read', label: 'View Departments' },
          { key: 'create', label: 'Add Department' },
          { key: 'update', label: 'Edit Department' },
          { key: 'delete', label: 'Delete Department / Designation' }
        ]
      },
      teams: {
        label: 'Teams Management',
        actions: [
          { key: 'read', label: 'View Teams' },
          { key: 'create', label: 'Add Team' },
          { key: 'update', label: 'Edit Team' },
          { key: 'delete', label: 'Delete Team' }
        ]
      },
      salary_template: {
        label: 'Salary Templates',
        actions: [
          { key: 'read', label: 'View Salary Templates' },
          { key: 'create', label: 'Add Salary Template' },
          { key: 'update', label: 'Edit Salary Template' },
          { key: 'delete', label: 'Delete Salary Template' }
        ]
      },
      leave: {
        label: 'Leave Management',
        actions: [
          { key: 'read', label: 'View Leave Plans' },
          { key: 'create', label: 'Add Leave Plan' },
          { key: 'update', label: 'Edit Leave Plan' },
          { key: 'delete', label: 'Delete Leave Plan' }
        ]
      },
      holiday: {
        label: 'Holiday Management',
        actions: [
          { key: 'read', label: 'View Holiday List' },
          { key: 'create', label: 'Add Holiday' },
          { key: 'update', label: 'Edit Holiday' },
          { key: 'delete', label: 'Delete Holiday' }
        ]
      }
    }
  },
  customers: {
    label: 'Customer Management',
    submodules: {
      details: {
        label: 'Customers Details',
        actions: [
          { key: 'read', label: 'View Customers' },
          { key: 'create', label: 'Add Customer' },
          { key: 'update', label: 'Edit Customer' },
          { key: 'delete', label: 'Delete Customer' },
          { key: 'export', label: 'Export Customers' }
        ]
      }
    }
  },
  accounting: {
    label: 'Accounting',
    submodules: {
      ledger_groups: {
        label: 'Ledger Groups (COA)',
        actions: [
          { key: 'read', label: 'View Ledger Groups' },
          { key: 'create', label: 'Add Ledger Group' },
          { key: 'update', label: 'Edit Ledger Group' },
          { key: 'delete', label: 'Delete Ledger Group' }
        ]
      },
      journal_entry: {
        label: 'Journal Entries',
        actions: [
          { key: 'read', label: 'View Journal Entries' },
          { key: 'create', label: 'Create Journal Entry' },
          { key: 'update', label: 'Edit/Reverse Journal' },
          { key: 'delete', label: 'Delete Journal' },
          { key: 'export', label: 'Export Journal Entries' }
        ]
      },
      bank_reconciliation: {
        label: 'Bank Reconciliation',
        actions: [
          { key: 'read', label: 'View Bank Reconciliation' },
          { key: 'write', label: 'Perform Bank Reconciliation' }
        ]
      },
      audit_logs: {
        label: 'Audit Logs',
        actions: [{ key: 'read', label: 'View Audit Logs' }]
      }
    }
  },
  workflows: {
    label: 'Workflow Setup',
    submodules: {
      templates: {
        label: 'Workflow Templates',
        actions: [
          { key: 'read', label: 'View Workflow Templates' },
          { key: 'create', label: 'Add Workflow Template' },
          { key: 'update', label: 'Edit Workflow Template' },
          { key: 'delete', label: 'Delete Workflow Template' }
        ]
      },
      loan_rules: {
        label: 'Loan Rules',
        actions: [
          { key: 'read', label: 'View Loan Rules' },
          { key: 'create', label: 'Add Loan Rule' },
          { key: 'update', label: 'Edit Loan Rule' },
          { key: 'delete', label: 'Delete Loan Rule' }
        ]
      }
    }
  },
  reports: {
    label: 'Reports Dashboard',
    submodules: {
      dashboard: {
        label: 'Dashboard Options',
        actions: [
          { key: 'read', label: 'View Reports' },
          { key: 'export', label: 'Download Reports' }
        ]
      },
      loan_management: {
        label: 'Loan Management Reports Tab',
        actions: [{ key: 'read', label: 'Access Loan Management Tab' }]
      },
      financial: {
        label: 'Financial Reports Tab',
        actions: [{ key: 'read', label: 'Access Financial Reports Tab' }]
      },
      workforce: {
        label: 'Workforce Reports Tab',
        actions: [{ key: 'read', label: 'Access Workforce & Attendance Tab' }]
      },
      collection: {
        label: 'Collection Management Reports Tab',
        actions: [{ key: 'read', label: 'Access Collection Management Tab' }]
      }
    }
  },
  batch_reports: {
    label: 'Batch Reports',
    submodules: {
      batch: {
        label: 'Batch Options',
        actions: [
          { key: 'read', label: 'View Batch Reports' },
          { key: 'delete', label: 'Abort/Delete Batch Jobs' }
        ]
      }
    }
  },
  notifications: {
    label: 'Notification Integration',
    submodules: {
      inbox: {
        label: 'Notifications Inbox & Logs',
        actions: [{ key: 'read', label: 'View Inbox Notifications & WhatsApp Logs' }]
      },
      templates: {
        label: 'Notification Letter Templates',
        actions: [
          { key: 'read', label: 'View Letter Templates' },
          { key: 'create', label: 'Add/Create Letter Template' },
          { key: 'update', label: 'Edit/Sync Letter Template' },
          { key: 'delete', label: 'Delete Letter Template' }
        ]
      },
      triggers: {
        label: 'Notification Event Triggers',
        actions: [
          { key: 'read', label: 'View Notification Triggers' },
          { key: 'create', label: 'Add/Create Trigger' },
          { key: 'update', label: 'Edit Trigger' },
          { key: 'delete', label: 'Delete Trigger' }
        ]
      }
    }
  },
  alerts: {
    label: 'Notification Alerts & Requests',
    submodules: {
      alerts: {
        label: 'Alerts & Approval Requests',
        actions: [
          { key: 'read', label: 'View Alerts/Requests' },
          { key: 'write', label: 'Process/Approve Requests' }
        ]
      }
    }
  },
  learning: {
    label: 'Learning & Trainings',
    submodules: {
      courses: {
        label: 'Courses & Chapters',
        actions: [
          { key: 'read', label: 'View Courses' },
          { key: 'create', label: 'Create Courses' },
          { key: 'update', label: 'Edit Courses' },
          { key: 'delete', label: 'Delete Courses' }
        ]
      },
      user_progress: {
        label: 'User Progress',
        actions: [{ key: 'read', label: 'View User Progress & Completions' }]
      }
    }
  },
  dynamic_forms: {
    label: 'Dynamic Forms & Responses',
    submodules: {
      forms: {
        label: 'Form Templates',
        actions: [
          { key: 'read', label: 'View Form Templates' },
          { key: 'create', label: 'Create/Add Form Template' },
          { key: 'update', label: 'Edit Form Template' },
          { key: 'delete', label: 'Delete Form Template' }
        ]
      },
      responses: {
        label: 'Form Responses',
        actions: [
          { key: 'read', label: 'View Responses' },
          { key: 'create', label: 'Submit Responses' },
          { key: 'update', label: 'Edit Responses' }
        ]
      }
    }
  },
  settings: {
    label: 'Settings Configuration',
    submodules: {
      organization: {
        label: 'Organization Configs',
        actions: [
          { key: 'read', label: 'Access Organization Setup Tab' }
        ]
      },
      app_config: {
        label: 'Configure Employee App',
        actions: [
          { key: 'read', label: 'Access App Configurations Tab' },
          { key: 'write', label: 'Save/Update App Configurations & Switches' }
        ]
      }
    }
  }
}

// Global cache populated during app initialization or setup
export const DYNAMIC_MODULES = {}

export function registerDynamicUseCase(useCase, navName, subCases = []) {
  const submodules = {}
  subCases.forEach((subCase) => {
    const displayName = subCase.name.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
    const actions = [
      { key: 'read', label: 'View / Read Usecase' },
      { key: 'write', label: 'Create / Update Usecase' },
      { key: 'delete', label: 'Delete Usecase' },
      { key: 'export', label: 'Export Usecase' },

      { key: 'cases.read', label: 'Cases Tab: View' },
      { key: 'cases.write', label: 'Cases Tab: Add/Edit' },
      { key: 'cases.delete', label: 'Cases Tab: Delete' },
      { key: 'cases.export', label: 'Cases Tab: Export' },

      { key: 'visits.read', label: 'Visits Tab: View' },
      { key: 'visits.write', label: 'Visits Tab: Add/Edit' },
      { key: 'visits.delete', label: 'Visits Tab: Delete' },
      { key: 'visits.export', label: 'Visits Tab: Export' },

      { key: 'case_analytics.read', label: 'Analytics Tab: View' },
      { key: 'case_analytics.export', label: 'Analytics Tab: Export' },

      { key: 'call_history.read', label: 'Call History Tab: View' },
      { key: 'call_history.export', label: 'Call History Tab: Export' },

      { key: 'customers.read', label: 'Customers Tab: View' },
      { key: 'customers.write', label: 'Customers Tab: Add/Edit' },
      { key: 'customers.delete', label: 'Customers Tab: Delete' },
      { key: 'customers.export', label: 'Customers Tab: Export' },

      { key: 'audit.read', label: 'Audit Tab: View' }
    ]

    if (useCase === 'loan_management') {
      actions.push(
        // Case Details Dynamic Sub-Tabs
        { key: 'details.read', label: 'Case Details: View Info' },
        { key: 'disbursements.read', label: 'Case Details: View Disbursements' },
        { key: 'emi_schedule.read', label: 'Case Details: View EMI Schedule' },
        { key: 'emi_schedule.write', label: 'Case Details: Add/Edit EMI Schedule' },
        { key: 'emi_schedule.delete', label: 'Case Details: Revert/Delete Installment' },
        { key: 'charges.read', label: 'Case Details: View Charges (VAS)' },
        { key: 'pre_payment.read', label: 'Case Details: View Pre-Payment' },
        { key: 'pre_payment.write', label: 'Case Details: Add/Edit Pre-Payment' },
        { key: 'pre_payment.delete', label: 'Case Details: Revert/Delete Pre-Payment / Foreclosure' },
        { key: 'soa.read', label: 'Case Details: View Statement of Account' },
        { key: 'ledger.read', label: 'Case Details: View Customer Ledger' },
        { key: 'documents.read', label: 'Case Details: View Documents' },
        { key: 'documents.delete', label: 'Case Details: Delete Documents' },
        { key: 'audit_trail.read', label: 'Case Details: View Loan Audit Trail' }
      )
    }

    submodules[subCase._id] = {
      label: displayName,
      actions
    }
  })

  DYNAMIC_MODULES[useCase] = {
    label: navName || useCase.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()),
    submodules
  }
}

export function getFlatPermissionOptions() {
  const options = []

  const allRegistries = { ...PERMISSION_REGISTRY, ...DYNAMIC_MODULES }

  for (const [modKey, modObj] of Object.entries(allRegistries)) {
    // Module wildcard
    if (modKey !== 'global') {
      options.push({
        key: `${modKey}.*`,
        label: `${modObj.label} (Full Module Access - ${modKey}.*)`
      })
    }

    if (modObj.submodules) {
      for (const [subKey, subObj] of Object.entries(modObj.submodules)) {
        // Submodule wildcard
        if (modKey !== 'global' || subKey !== 'system') {
          const displayKey = `${modKey}.${subObj.label || subKey}.*`
          options.push({
            key: `${modKey}.${subKey}.*`,
            displayKey: displayKey,
            label: `${modObj.label} > ${subObj.label} (All Actions - ${displayKey})`,
            description: `Grants full access to all submodule activities under ${subObj.label}.`
          })
        }

        if (subObj.actions) {
          for (const act of subObj.actions) {
            if (modKey === 'global' && subKey === 'system' && act.key === '*') {
              options.push({
                key: `${modKey}.${subKey}.${act.key}`,
                displayKey: `global.system.*`,
                label: `Global Settings > System Access Control > System* (Full Access Bypass - global.system.*)`,
                description: `Bypasses all authorization rules. Grants complete owner privileges across the entire application.`
              })
            } else {
              const displayKey = `${modKey}.${subObj.label || subKey}.${act.key}`
              options.push({
                key: `${modKey}.${subKey}.${act.key}`,
                displayKey: displayKey,
                label: `${modObj.label} > ${subObj.label} > ${act.label} (${displayKey})`,
                description: act.description || `Allows performing the "${act.label}" action in ${subObj.label}.`
              })
            }
          }
        }
      }
    }
  }

  return options
}

export default {
  PERMISSION_REGISTRY,
  getFlatPermissionOptions
}
